<template>
  <div>
    <search-list @findData="findData" ></search-list>
  <div class="page-wrapper">
    <Button type="primary" class="mb16 " @click.stop="toAdd" v-p="{api:'invoice/saveInvoiceCompetency'}">新增</Button>
    <table-list
      title="" :columns="columns" :data="data" :loading="loading" :total="total" :current="current" @change-page="changePage"
    ></table-list>
  </div>
   <add :n="addN" :projectList="projectList" @show-img="showImg" :comanyAddrList="comanyAddrList" @done="invoiceCompetencylist"></add>

    <update :n="updateN" :projectList="projectList" :fid="fid" @show-img="showImg" :comanyAddrList="comanyAddrList" @done="invoiceCompetencylist"></update>
    <detail :n="viewN" :projectList="projectList" :fid="fid" @show-img="showImg" ></detail>
    <img-show :n="showImgKey" :src="imgSrc"></img-show>
  </div>
</template>


<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import Add from './components/Add'
  import {invoiceCompetencylist} from "../../../api/invoice";
  import {getProjects} from "../../../api/common";
  import Update from './components/Update'
  import UpdateOrder from "../../marketConfig/houseTypeConfig/components/updateOrder";
  import {formatDateTime} from "../../../utils/format";
  import Detail from './components/Detail';
  import {getCompanyRegdAddress} from "../../../api/invoice"
  import ImgShow from 'components/ImgShow/index'

  export default {
    name: "specialreview",
    components:{
      UpdateOrder,
      SearchList,
      TableList,
      Add,
      Update,
      Detail,
      ImgShow
    },
    data(){
      return {
        viewN:0,
        fid:'',
        updateN:0,
        projectList:[],
        addN:0,
        loading:false,
        total:0,
        current:1,
        imgSrc:'',
        showImgKey:0,
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:' '
          },
          {
            title: "公司名称",
            key: "companyName",
            align: "center",
            width:160
          },
          {
            title:' '
          },
          {
            title: "纳税人识别号",
            key: "taxIdfa",
            align: "center",
            width:140
          },
          {
            title:' '
          },
          {
            title: "申请日期",
            key: "applyDate",
            align: "center",
            width:120,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['applyDate'],false))
            }
          },
          {
            title:' '
          },
          {
            title: "申请状态",
            key: "applyStateCn",
            align: "center",
            width:120,
            render:(h,params)=>{
              return h('span',{},params.row['applyStateCn'])
            }
          },
          {
            title:' '
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
             width:160,
          },
          {
            title:' '
          },
          {
            title: "操作",
            width:150,
            fixed:'right',
            key: "action",
            align: "center",
            render:(h,params)=>{
              let update=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'invoice/updateInvoiceCompetency'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.updateN++
                  }
                },
                style:{
                  marginLeft:'10px'
                }
              },'修改')

              let detail=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'invoice/getInvoiceCompetency'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.viewN++
                  }
                },
              },'查看')
              let actions=[detail]
              // params.row['projectCooperationModel']!==0 && actions.push(update)
              if (params.row['projectCooperationModel'] !== 0) {
                actions.push(update)
              }else {
                if ( params.row['applyState'] !== '02') {
                  actions.push(update)
                }
              }
              return h('div',{},actions)
            }
          },
        ],
        data:[],
        searchData: {
          projectFid:'',
          applyDateStart:'',
          applyDateEnd:'',
          q:'',
          page:1,
          limit:10
        },
        comanyAddrList:[]
      }
    },
    methods:{
      invoiceCompetencylist(){
        invoiceCompetencylist(this.searchData).then(res=>{
          this.data=res.data.rows
          this.total=res.data.total
        }).catch(error=>{})
      },
      toAdd(){
        this.addN++
      },
      showImg(img) {
        this.imgSrc = img
        this.showImgKey++
      },
      findData(params){
        this.current=1
        this.searchData = Object.assign({}, params);
        this.invoiceCompetencylist();
      },
      changePage(n){
        this.current=n
        this.searchData.page = n;
        this.invoiceCompetencylist();
      }
    },
    created(){
      getProjects().then(res=>{
        res.data && (this.projectList=res.data)
      }).catch(error=>{})
      getCompanyRegdAddress().then(res=>{
        res.data && (this.comanyAddrList=res.data)
      }).catch(error=>{})
      this.invoiceCompetencylist()
    }
  }
</script>

<style scoped>

</style>
